// src/data/rulingRef.js
//
// RULING 168 (2026-09-17, Bob's decision D-18): how a ruling number reaches a screen.
//   - a member (and a tester) sees PLAIN LANGUAGE; the number sits behind a "Why?" popup;
//   - a General or Local Chairperson (and the administrator) sees the same plain language with an
//     end-of-line tag "[R-nn]".
// This file is the one place that decides which; src\components\RulingRef.js draws it. Every
// on-screen ruling mention goes through these two so the rule is applied once (directives XI).

export function isOfficer(user) {
  return !!user && (user.isAdmin === true || user.role === 'admin' || user.role === 'general_chair' || user.role === 'local_chair');
}

// The number as a tag, or nothing. `n` may be a number or a string like '61.6'.
export function rulingTag(user, n) {
  if (!isOfficer(user)) return '';
  const s = String(n == null ? '' : n).trim();
  if (!/^\d+(\.\d+)?$/.test(s)) return '';
  return '[R-' + s + ']';
}

// What the popup says for a member. `why` is the caller's plain-language reason; the number is
// appended so the member can quote it back if he asks, without it sitting in his face.
export function whyText(n, why) {
  const s = String(n == null ? '' : n).trim();
  const w = String(why || '').trim();
  if (!/^\d+(\.\d+)?$/.test(s)) return w;
  return (w ? w + ' ' : '') + '(Ruling ' + s + '.)';
}

// Presentation decision for a component: which of the two shapes to draw.
export function refMode(user) {
  return isOfficer(user) ? 'tag' : 'why';
}
